import { ColorBrandBlue1, ColorNeutralBlack } from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';

const filledHeart = css`
    fill: var(--color-favorite);
    stroke: var(--color-favorite);
`;

const filledBlackedHeart = css`
    fill: #000;
    stroke: #000;
`;

const disabledHeart = css`
    fill: ${ColorNeutralBlack};
    stroke: ${ColorNeutralBlack};
`;

const customBaseStyling = css`
    && {
        background-color: transparent;
        padding: 0;
        aspect-ratio: 1;

        &:hover,
        &:focus,
        &:active,
        &:disabled {
            background-color: transparent;
            outline-color: transparent;
        }

        &:focus-visible {
            outline-color: ${ColorBrandBlue1};
        }

        &:active svg {
            ${filledHeart}
        }

        &:disabled {
            opacity: 0.2;

            svg {
                ${disabledHeart}
            }
        }
    }
`;

const customVariantsStyling = {
    chanel: {
        default: css`
            ${customBaseStyling}

            &:active svg {
                ${filledBlackedHeart}
            }
        `,
        favorite: css`
            ${customBaseStyling}

            &:active svg,
            svg {
                ${filledBlackedHeart}
            }
        `
    },
    favoriteGhost: {
        default: css`
            width: 100%;
            ${customBaseStyling}
        `,
        favorite: css`
            width: 100%;
            ${customBaseStyling}

            svg {
                ${filledHeart}
            }
        `
    },
    favoriteGhostHorizontal: {
        default: css`
            ${customBaseStyling}

            &:focus {
                outline-color: #f6f6f6;
                outline-style: solid;
            }

            &:focus-visible {
                outline-color: ${ColorBrandBlue1};
            }
        `,
        favorite: css`
            ${customBaseStyling}

            &:focus {
                outline-color: #f6f6f6;
                outline-style: solid;
            }

            &:focus-visible {
                outline-color: ${ColorBrandBlue1};
            }

            svg {
                ${filledHeart}
            }
        `
    }
};

export { customVariantsStyling, filledHeart };
